import { ColumnValueSegment, IColumnDataSource, IReportDatasetLens } from '@opengov/reporting-types';
import { lensEffects } from '../lenses/lensEffects';
import { reportExplorerActionCreators } from './state';

export interface MultiDatasetColumnClick {
  columnIndex: number;
  lens?: IReportDatasetLens;
  segment?: ColumnValueSegment[];
  /** The path of the clicked leaf, so an edit is written at the depth the column actually sits at. */
  columnPath?: ColumnValueSegment[];
  level?: number;
  source?: IColumnDataSource;
}

/**
 * What a click on a multi-dataset column header does. The route loader and the query effect both
 * build the grid's columns, and the loader's columns can stay in use, so they have to share this one
 * handler: a second copy that forgot `columnPath` and `level` would write a nested column's rename
 * under a key nothing reads.
 */
export function onMultiDatasetColumnClick({
  columnIndex,
  lens,
  segment,
  columnPath,
  level,
  source
}: MultiDatasetColumnClick): void {
  reportExplorerActionCreators.setSelectedColumnEditorLensId(null);
  if (segment && source) {
    reportExplorerActionCreators.setSegmentColEditMode({ columnIndex, segment, columnPath, level, source });
  } else {
    reportExplorerActionCreators.setEditColEditMode(columnIndex);
  }
  if (lens) {
    void lensEffects.getLensWithColumns(lens.id);
  }
}
